import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import SocialStateContext from '../src/context/SocialStateContext';

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <SocialStateContext>
        <App />
      </SocialStateContext>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);